<template lang="pug">
  .component-policy-button
    .dropdown-buttons
      ActionButton(:action="remove", :confirm="true") Delete

</template>

<script>
  import ModalReveal from '../../foundation/ModalReveal'
  import ActionButton from '../ActionButton'
  import KeplerBackofficeSdk from '../../../../lib/kepler/backoffice'

  export default {
    name: 'UserButtons',
    components: {ActionButton, ModalReveal},
    data() {
      return {}
    },
    created() {


    },

    methods: {
      remove() {
        return KeplerBackofficeSdk.users.select(this.item).remove(() => {
          this.$emit('itemUpdated')
        })
      }
    },

    props: ['item']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// UserButtons.vue?86ad7150